import { Suspense } from 'react';
import { lazily } from 'react-lazily';

import { useFeatureFlag, Variant } from '@bonusly/who-am-i';

import { AppLayout } from '.';
import { AppContent } from '../../app/app-content';
import { App as TopNavbar } from '../../modules/top-navbar/components/App';
import { MobileActionBar } from '../action-bar/mobile-action-bar';
import { Reveal } from '../display/reveal';

const { GlobalModals } = lazily(() => import('../../app/global-modals'));

export const AppRootLayout = () => {
	const isHomepageRedesignEnabled = useFeatureFlag(Variant.HomepageRedesign);

	return (
		<AppLayout navbar={<TopNavbar />}>
			<Suspense>
				<GlobalModals />
			</Suspense>

			<AppContent />

			{/* Old MobileActionBar - only shown when homepage redesign is disabled */}
			<Reveal if={!isHomepageRedesignEnabled}>
				<MobileActionBar />
			</Reveal>
		</AppLayout>
	);
};
